// src/services/estoque/NotaItemEntradaService.js
import { fetchData } from '../Api';

export const buscarItensEntrada = async ({
    periodoInicial,
    periodoFinal,
    horaInicial,
    horaFinal,
    fornecedorNome,
    produtoDescricao,
}) => fetchData('/NotaItem', {
    naturezaId: 2,
    dataLanIni: `${periodoInicial}T${horaInicial || '00:00'}:00`,
    dataLanFim: `${periodoFinal}T${horaFinal || '23:59'}:59`,
    fornecedorNome: fornecedorNome || null,
    produtoDescricao: produtoDescricao || null,
});
